
import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { User, Database, Users, Bell } from 'lucide-react';
import NavigationItem from './NavigationItem';

interface OrganizationSectionContentProps {
  activeTab: string;
  onChange: (value: string) => void;
}

const OrganizationSectionContent = ({ 
  activeTab, 
  onChange 
}: OrganizationSectionContentProps) => {
  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <NavigationItem 
              active={activeTab === 'account'} 
              onClick={() => onChange('account')}
              icon={<User className="h-4 w-4 mr-2" />}
              label="Account"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="max-w-xs">Manage your account settings and preferences</p>
        </TooltipContent>
      </Tooltip>
      
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <NavigationItem 
              active={activeTab === 'datasources'} 
              onClick={() => onChange('datasources')}
              icon={<Database className="h-4 w-4 mr-2" />}
              label="Data Sources"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="max-w-xs">Configure SCADA, BMS, and IoT integrations</p>
        </TooltipContent>
      </Tooltip>
      
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <NavigationItem 
              active={activeTab === 'users'} 
              onClick={() => onChange('users')}
              icon={<Users className="h-4 w-4 mr-2" />}
              label="Users"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="max-w-xs">Manage user accounts, roles and permissions</p>
        </TooltipContent>
      </Tooltip>
      
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <NavigationItem 
              active={activeTab === 'notifications'} 
              onClick={() => onChange('notifications')}
              icon={<Bell className="h-4 w-4 mr-2" />}
              label="Notifications"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="max-w-xs">Configure system alerts and notification preferences</p>
        </TooltipContent>
      </Tooltip>
    </>
  );
};

export default OrganizationSectionContent;
